<div class="p-4">
  @if (!isMailSent) {
    <div class="p-4">
      <h2>Email Verification Required</h2>
      <p>Please verify your email ID to continue using the app.</p>
      @if (!isMailSending) {
        <button class="primary-btn ms-1 me-2" mat-flat-button aria-label="Verify Email button"
          matTooltip="Verify Email" (click)="verifyEmail()">
          <mat-icon>mail</mat-icon>Verify Email
        </button>
      }
      @if (isMailSending) {
        <button class="primary-btn ms-1 me-2" mat-flat-button aria-label="Verify Email button"
          matTooltip="Verify Email" disabled>
          <div class="w-100 d-inline-flex p-2"><img src="svg/spinner_icon.svg" alt="Logo"
          class="rotate-image logo">&nbsp;Sending Mail</div>
        </button>
      }
      @if (isLogoutButtonVisible()) {
        <button class="secondary-btn ms-1 me-2" mat-flat-button aria-label="Logout button" matTooltip="Logout"
          (click)="logout()"><mat-icon class="font-dark">logout</mat-icon>Logout</button>
        }
        @if (!isLogoutButtonVisible()) {
          <button class="secondary-btn ms-1 me-2" mat-flat-button aria-label="Logout button"
            matTooltip="Logout" (click)="closeDialogue()"><mat-icon class="font-dark">close</mat-icon>Close</button>
          }
        </div>
      }

      @if (isMailSent) {
        <div class="p-4">
          <h2>Enter Verification Code</h2>
          <p>Please enter the verification code sent to your email ID.</p>
          <form [formGroup]="emailVerificationForm" (ngSubmit)="verifyCode()">
            <!-- <mat-label>Verification Code</mat-label> -->
            <mat-form-field appearance="outline" class="w-100">
              <mat-icon matPrefix>code</mat-icon>
              <input matInput formControlName="verification_code" placeholder="Enter verification code" maxlength="6" pattern="[A-Za-z0-9]{0,6}">
              @if (emailVerificationForm.get('verification_code')?.hasError('required')) {
                <mat-error>
                  Verification Code is required
                </mat-error>
              }
            </mat-form-field>
            @if (!isVerificationInProgress) {
              <button class="primary-btn ms-1 me-2" mat-flat-button
                aria-label="Verify Email button" matTooltip="Verify Code" type="submit">
                <mat-icon>code</mat-icon>Verify Code
              </button>
            }
            @if (isVerificationInProgress) {
              <button class="primary-btn ms-1 me-2" mat-flat-button
                aria-label="Verify Email button" matTooltip="Verify Email" disabled>
                <div class="w-100 d-inline-flex p-2"><img src="svg/spinner_icon.svg" alt="Logo"
                class="rotate-image logo">&nbsp;Verifying Code</div>
              </button>
            }
            @if (isLogoutButtonVisible()) {
              <button class="secondary-btn ms-1 me-2" mat-flat-button aria-label="Logout button" matTooltip="Logout"
                (click)="logout()"><mat-icon class="font-dark">logout</mat-icon>Logout</button>
              }
              @if (!isLogoutButtonVisible()) {
                <button class="secondary-btn ms-1 me-2" mat-flat-button aria-label="Logout button"
                  matTooltip="Logout" (click)="closeDialogue()"><mat-icon class="font-dark">close</mat-icon>Close</button>
                }
              </form>
            </div>
          }
        </div>